export * from "./api-endpoints"
export * from  "./app-routes"

export const UI_ELEMENT_TYPE = {
  BUTTON: 'Button',
  TAB: 'Tab'
};

export const NotificationEvents: Record<string,string> = {
    Payment_Requested: "Payment Requested",
    Payment_On_Hold: "Payment On Hold",
    Payment_Rejected: "Payment Rejected",
    High_Priority_Payment: "High Priority Payment",
    PROJECT_INVITE_ACCEPTED: "Project Invite Accepted",
    PROJECT_INVITE_DECLINED: "Project Invite Declined",
    PAYMENT_COMPLETED: "Payment Completed",
    PAYMENT_FAILED: "Payment Failed",
    COMPLIANCE_COMPLETED: "Compliance Completed",
    HONORARIUM_CHANGED: "Honorarium Changed",
    TIME_SLOT_SHARED: "Call Time Slot Shared"
}

export const SETTINGS_CONFIG_TYPE = {
  NotificationEvents: "NotificationEvents"
}